import { FC } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { DifficultRoute } from 'entities/ticket/models/find-ticket/models'

import { dateFormat } from 'shared/lib//dateFormat'
import { IErrorForm } from 'shared/lib/validate'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import { FlightSegmentFields } from './ui/flight-segment-fields'

import s from './styles.module.scss'

interface Props {
  index?: number
  formList?: DifficultRoute[] | []
  onDeleteForm?: (index: number) => void
  onSwitchDirection?: (index: number) => void
  errors?: IErrorForm
}

export const DifficultForm: FC<Props> = ({
  formList = [],
  onDeleteForm,
  onSwitchDirection,
  errors,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onClickToSearch = (route: string) => {
    navigate?.(RoutingPaths.avia.searchDirection.path(route))
  }

  const onClickCalendar = (index: number) => {
    navigate(`${RoutingPaths.avia.calendar.path()}/?difficult=${index}`)
  }

  return (
    <div className={s.container}>
      {formList?.map((form, index) => {
        const resultDate = form?.date?.length
          ? dateFormat(form?.date || '')
          : ''

        return (
          <div
            className={s.segment}
            key={`${form.from?.cityIataCode}${form.to?.cityIataCode}${index}`}
          >
            <p className={s.segmentTitle}>
              {t('transfer_title_number', { count: index + 1 })}
            </p>

            <div className={s.segmentCard}>
              <Paper
                padding={[12]}
                radius="24px"
              >
                <FlightSegmentFields
                  from={{
                    name: form?.from?.cityName,
                    code: form?.from?.cityIataCode,
                  }}
                  to={{
                    name: form?.to?.cityName,
                    code: form?.to?.cityIataCode,
                  }}
                  date={resultDate}
                  onClickFrom={() =>
                    onClickToSearch(`from/?difficult=${index}`)
                  }
                  onClickTo={() => onClickToSearch(`to/?difficult=${index}`)}
                  onClickDate={() => onClickCalendar(index)}
                  onSwitch={() => onSwitchDirection?.(index)}
                  fromError={
                    !!errors?.[`directions[${index}].from.cityIataCode`]
                  }
                  toError={!!errors?.[`directions[${index}].to.cityIataCode`]}
                  dateError={!!errors?.[`directions[${index}].date`]}
                />
              </Paper>

              {index !== 0 ? (
                <button
                  type="button"
                  className={s.deleteButton}
                  onClick={() => onDeleteForm?.(index)}
                  aria-label={t('delete')}
                >
                  <AppIcon
                    id={AllIcons.CROSS}
                    height={12}
                    width={12}
                    color="var(--white)"
                  />
                </button>
              ) : null}
            </div>
          </div>
        )
      })}
    </div>
  )
}
